import { avlPrefix } from '#avl/constants'
import { AvlPair, MigrationItem, useAvlRowParser } from '#migration/migration-avl'
import { iotcnumberscheme } from '#vid/constants'
import { useVID } from '#vid/model'
import { utils } from 'apprise-core/utils'
import { XlsXParseContext } from 'apprise-frontend-parse/file'
import { ParseContext, ResourceParseOutcome } from 'apprise-frontend-parse/model'
import { useDefaultModelParser, useDefaultParser } from 'apprise-frontend-parse/resource'
import { useDefaultBookParser } from 'apprise-frontend-parse/workbook'
import { useAsyncTask } from 'apprise-ui/utils/asynctask'
import { avlmigrationConfig } from './config.avl'



export const useAvlRavMigration = (rows?: number) => {

    const config = rows ? { ...avlmigrationConfig, rowRadius: rows } : avlmigrationConfig

    const itemParser = useAvlRavMigrationItemParser()
    const modelparser = useDefaultModelParser(itemParser)
    const bookparser = useDefaultBookParser(modelparser, [], () => config)

    const groupActiveYears = (outcome: ResourceParseOutcome<AvlPair>) => {

        const grouped = Object.values(utils().index(outcome.data).byGroup(e => e.uvi)).map(pairs => {

            const reduced = pairs.reduce((merged, pair) => {

                // bootstrap accumulation
                if (!merged.patch)
                    return pair

                merged.patch.declarations.push(...pair.patch.declarations)

                return merged

            }, {} as AvlPair)

            reduced.patch.declarations.sort()

            return reduced


        })

        return { ...outcome, data: grouped }

    }



    const parse = useDefaultParser<AvlPair, ParseContext<XlsXParseContext>>({ modelparser, bookparser, postProcess: groupActiveYears })

    const migrate = async (props: { file: File }) => {

        const { file } = props

        console.log(`migrating ${rows || 'all'} record from ${file.name}`)

        const resource = { id: file.name, name: file.name, file }

        return await parse(resource, {})

    }

    const task = useAsyncTask()

    return task.make(migrate).with(config => config.notify().wait(100).show(({ file }) => `migrating ${rows || 'all'} records...`)).done()

}

const useAvlRavMigrationItemParser = () => {

    const vids = useVID()

    const parseAvl = useAvlRowParser()

    return (row: MigrationItem): AvlPair => {

        const timestamp = new Date(row.date)

        return {

            uvi: vids.stringify(iotcnumberscheme, `IOTC${row.uvi?.padStart(6, '0')}`),
            patch: {

                id: utils().mint(avlPrefix),
                timestamp: timestamp.toISOString(),
                declarations: [parseAvl(row)]

            }

        } as AvlPair



    }

}

